export default [
    "s_flight_number",
    "t_depart_date",
    "s_origin",
    "s_destination",
    "i_weight",
    "i_pieces",
    "s_transport_type",
    "s_iac",
    "s_port_of_unlading",
    "s_commodity",
    "s_shc1",
    "s_shc2",
    "s_shc3",
    "s_shc4",
    "s_shc5",
    "b_dg",
    "b_screened",
    "s_ccsf",
    "s_non_iac",
    "s_company_driver_name",
    "s_company_driver_id_type_1",
    "s_company_driver_id_num_1",
    "d_company_driver_id_expiration_1",
    "b_company_driver_photo_match_1",
    "s_company_driver_id_type_2",
    "s_company_driver_id_num_2",
    "d_company_driver_id_expiration_2",
    "b_company_driver_photo_match_2",
    "s_notes",
    "s_counter_reject_reason"
]